import React from 'react';
import { Box, SxStyleProp, Text } from '@tishman/components';
import { H } from '@hzdg/sectioning';

import { PrivateEventsHeroCta } from './PrivateEventsHeroCta';

type TPrivateEventsHeroTextSection = {
  cta?: {
    link?: string;
    caption?: string;
  };
  eyebrow?: string;
  title?: string;
  paragraph?: string;
  showMobileCta: boolean;
  showTabletCta?: boolean;
  titleLetterSpacing: (number | string)[];
  titleSx?: SxStyleProp;
  pageName: string;
};

export const PrivateEventsHeroTextSection = ({
  cta,
  eyebrow,
  title,
  paragraph,
  showMobileCta,
  showTabletCta,
  titleLetterSpacing,
  titleSx = {},
  pageName,
}: TPrivateEventsHeroTextSection) => {
  return (
    <Box sx={{ maxWidth: '665px', pr: [0, 1], mt: [0, '5px'] }}>
      {eyebrow && (
        <Text
          as="p"
          sx={{
            color: '#7D7369',
            mb: [3, 0],
          }}
          variant="bodyEmphasis"
        >
          {eyebrow}
        </Text>
      )}
      <H
        level={1}
        sx={{
          variant: 'text.introTextHeading',
          mb: 3,
          px: 0,
          fontSize: [6, 7, 8],
          marginTop: [1, '30px'],
          letterSpacing: titleLetterSpacing,
          lineHeight: [1.2, 1.15],
          ...titleSx,
        }}
      >
        {title}
      </H>
      {paragraph && (
        <Text
          as="p"
          sx={{
            fontSize: [2, 3],
            letterSpacing: [3, 3],
            opacity: 0.8,
          }}
        >
          {paragraph}
        </Text>
      )}

      {cta && (
        <PrivateEventsHeroCta
          caption={cta.caption}
          link={cta.link}
          pageName={pageName}
          showMobileCta={showMobileCta}
          showTabletCta={showTabletCta}
        />
      )}
    </Box>
  );
};
